import { Checkbox } from '@mui/material';
import React from 'react';
import { ClassnameAwareComponentProps } from '../../types';
import usePaymentFlow from '../../../hooks/payment/usePaymentFlow';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

export default function SavePaymentInfoConsent({ className }: ClassnameAwareComponentProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Payment:PaymentMethods:SavePaymentInfoConsent' });

  const { shouldSavePaymentInfo, setShouldSavePaymentInfo } = usePaymentFlow();

  return (
    <div className={classnames('flex', className)}>
      <Checkbox
        checked={shouldSavePaymentInfo ?? false}
        onChange={(e) => setShouldSavePaymentInfo(e.target.checked)}
        id="should-save-payment-info"
      />
      <label htmlFor="should-save-payment-info" className="ml-xs my-auto text-sm">
        {t('form.should_save_payment_info.label')}
      </label>
    </div>
  );
}
